import styled from 'styled-components';

import { Banner } from '@gympass/yoga';

export const StyledBanner = styled(Banner)`
  border-radius: ${({ theme }) => theme.yoga.radii.sharp};

  svg {
    fill: ${({ theme }) => theme.yoga.colors.stamina};
  }
`;

export const Span = styled.span`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
`;
